export default class CatalogVersion {
  constructor() {
    this.form = document.getElementById('catalog_update_version');

    if (this.form) {
      this.validator = window.solodev.formValidators[this.form.id];
      // This is callback called by header button.
      window.solodev.submitForm = () => this.form.submit();

      this.initForm();
    }
  }

  initForm() {

    const { validateResourceUrl } = this.form.dataset;

    // Validate resource url field.
    // --------------------------------------------------------------------------
    this.validator.addFieldValidation(
      this.form.id + '[resource_url]',
      (value, resolve, reject) => {
        $.ajax({
          url: validateResourceUrl,
          type: 'post',
          data: {
            url: value,
          },
          success() {
            resolve();
          },
          error(xhr) {
            reject(xhr.responseJSON.error);
          }
        })
      }
    );

    // Validate status field.
    // --------------------------------------------------------------------------
    this.validator.addFieldValidation(
      this.form.id + '[version_status]',
      (value, resolve, reject) => {
        if (
          value === 'active'
          && (!this.validator.getFieldValue(this.form.id + '[resource_url]') || this.validator.hasError(this.form.id + '[resource_url]'))
        ) {
          reject('Version cannot be set as "Active" if valid resource url is not specified.');
        } else {
          resolve();
        }
      }
    );

    setTimeout(() => {
      this.validator.validate()
    }, 1000);
  }
}
